export default __webpack_public_path__ + "static/media/Vindhyas_Mountain_Range_seen_from_Malwa_Plateau_Mandu_Mandav_Madhya_Pradesh_India_2009.3f7f77e7.jpg";